module.exports = __webpack_public_path__ + "img/maizego_h100.3e8e0146.png";